// Type aliases using auto-generated database types
import { Tables, TablesInsert, TablesUpdate } from './database.types'

// =====================================================
// ENUM DEFINITIONS
// =====================================================

export enum UserRole {
    ADMIN = 'admin',
    MANAGER = 'manager',
    QUALITY_CONTROL = 'quality_control',
    CUSTOMER = 'customer',
    AI = 'ai'
}

export enum TaskStatus {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}

export enum TaskPriority {
    LOWEST = 'lowest',
    LOW = 'low',
    NORMAL = 'normal',
    HIGH = 'high',
    HIGHEST = 'highest'
}

export enum AnswerStatus {
    OK = 'OK',
    NOK = 'NOK'
}

export enum QualityCheckStatus {
    IN_PROGRESS = 'in-progress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}

export enum BatchStatus {
    WAITING = 'waiting',
    IN_PRODUCTION = 'in_production',
    QC_PENDING = 'QC pending',
    COMPLETED = 'completed',
    SHIPPED = 'shipped'
}

export enum TaskMentionType {
    PROJECT = 'project',
    BATCH = 'batch',
    PRODUCTION_STAGE = 'production_stage',
    ORDER = 'order',
    USER = 'user'
}

export enum TaskRelatedType {
    PROJECT = 'project',
    ORDER = 'order',
    BATCH = 'batch',
    PRODUCTION_STAGE = 'production_stage',
    RFQ = 'rfq',
    SUPPLIER = 'supplier',
    FOLLOW_UP_CAMPAIGN = 'follow_up_campaign',
    FOLLOW_UP_COMMUNICATION_THREAD = 'follow_up_communication_thread',
    FOLLOW_UP_COMMUNICATION_MESSAGE = 'follow_up_communication_message',
    PART = 'part'
}

export enum NewUserRequestStatus {
    PENDING = 'pending',
    RESOLVED = 'resolved',
    REJECTED = 'rejected',
    DELETED_BY_USER = 'deleted_by_user'
}

export enum AuditAction {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    SOFT_DELETE = 'soft_delete',
    RESTORE = 'restore'
}

export enum BatchProductionStagePlanStatus {
    PLANNED = 'planned',
    READY = 'ready',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    PARTIALLY_COMPLETED = 'partially_completed',
    BLOCKED = 'blocked'
}

// Parts-related enums
export enum PartType {
    RAW_MATERIAL = 'raw_material',
    COMPONENT = 'component',
    SUB_ASSEMBLY = 'sub_assembly',
    FINISHED_PRODUCT = 'finished_product',
    CONSUMABLE = 'consumable',
    SERVICE = 'service'
}

export enum CompatibilityType {
    EQUIVALENT = 'equivalent',
    SUBSTITUTE = 'substitute',
    UPGRADE = 'upgrade',
    DOWNGRADE = 'downgrade'
}

export enum PricePer {
    UNIT = 'unit',
    PACKAGE = 'package',
    MASTER_CARTON = 'master_carton',
    PALLET = 'pallet',
    KG = 'kg',
    METER = 'meter',
    LITER = 'liter',
    SQUARE_METER = 'square_meter'
}

export enum DocumentType {
    DRAWING = 'drawing',
    DATASHEET = 'datasheet',
    MSDS = 'msds',
    CERTIFICATE = 'certificate',
    MANUAL = 'manual',
    OTHER = 'other'
}

export enum RfqQuoteStatus {
    RECEIVED = 'received',
    UNDER_REVIEW = 'under_review',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected'
}

export enum RfqSupplierStatus {
    PLANNED_TO_INVITE = 'planned_to_invite',
    INVITATION_SENT = 'invitation_sent',
    INVITATION_CONFIRMED = 'invitation_confirmed',
    DECLINED = 'declined',
    RESPONDED = 'responded',
    LATE = 'late',
    NO_RESPONSE = 'no_response'
}

export enum RfqStatus {
    DRAFT = 'draft',
    SENT = 'sent',
    PARTIAL_SENT = 'partial_sent',
    IN_PROGRESS = 'in_progress',
    EVALUATION = 'evaluation',
    AWARDED = 'awarded',
    CANCELLED = 'cancelled',
    CLOSED = 'closed'
}

export enum RfqPriority {
    LOW = 'low',
    NORMAL = 'normal',
    HIGH = 'high',
    URGENT = 'urgent'
}

export enum FollowUpActionStatus {
    PLANNED = 'planned',
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    SKIPPED = 'skipped',
    FAILED = 'failed'
}

export enum FollowUpCampaignStatus {
    PLANNED = 'planned',
    ACTIVE = 'active',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}

export enum FollowUpEntityType {
    RFQ_SUPPLIER = 'rfq_supplier',
    ORDER = 'order',
    BATCH = 'batch'
}

export enum FollowUpMethod {
    EMAIL = 'email',
    PHONE = 'phone',
    MEETING = 'meeting',
    OTHER = 'other'
}

export enum FollowUpPurpose {
    QUOTE_COLLECTION = 'quote_collection',
    DELIVERY_TRACKING = 'delivery_tracking',
    MANUFACTURING_PROGRESS_TRACKING = 'manufacturing_progress_tracking',
    STATUS_UPDATE = 'status_update',
    DOCUMENT_REQUEST = 'document_request',
    GENERAL_INQUIRY = 'general_inquiry'
}

export enum FollowUpCommunicationChannel {
    EMAIL = 'email',
    PHONE = 'phone',
    WHATSAPP = 'whatsapp',
    VIBER = 'viber',
    TELEGRAM = 'telegram',
    MEETING = 'meeting',
    IN_PERSON = 'in_person',
    INTERNAL_NOTE = 'internal_note',
    OTHER = 'other'
}

export enum FollowUpCommunicationDirection {
    INBOUND = 'inbound',
    OUTBOUND = 'outbound',
    INTERNAL = 'internal'
}

export enum OrderStatus {
    DRAFT = 'draft',
    SENT = 'sent',
    CONFIRMED = 'confirmed',
    IN_PRODUCTION = 'in_production',
    READY_TO_SHIP = 'ready_to_ship',
    SHIPPED = 'shipped',
    DELIVERED = 'delivered',
    CANCELLED = 'cancelled'
}

export enum TimelineHealth {
    ON_TRACK = 'on_track',
    AT_RISK = 'at_risk',
    DELAYED = 'delayed',
    CRITICAL = 'critical',
    COMPLETED = 'completed',
    NOT_STARTED = 'not_started'
}

export enum InboundEmailType {
    RFQ_RESPONSE = 'rfq_response',
    FOLLOW_UP_RESPONSE = 'follow_up_response',
    TASK_REPLY = 'task_reply',
    ORDER_INQUIRY = 'order_inquiry',
    GENERAL = 'general',
    AUTO_REPLY = 'auto_reply',
    BOUNCE = 'bounce'
}

export enum EmailEntityType {
    RFQ = 'rfq',
    RFQ_SUPPLIER = 'rfq_supplier',
    ORDER = 'order',
    TASK = 'task',
    BATCH = 'batch',
    FOLLOW_UP_CAMPAIGN = 'follow_up_campaign'
}

export enum OutboundEmailEventType {
    TASK_CREATED = 'task_created',
    TASK_ASSIGNED = 'task_assigned',
    TASK_COMMENT = 'task_comment',
    TASK_DUE_SOON = 'task_due_soon',
    TASK_OVERDUE = 'task_overdue',
    TASK_COMPLETED = 'task_completed',
    RFQ_SENT = 'rfq_sent',
    RFQ_REMINDER = 'rfq_reminder',
    FOLLOW_UP_REQUEST = 'follow_up_request',
    ORDER_CONFIRMED = 'order_confirmed',
    DAILY_DIGEST = 'daily_digest',
    WEEKLY_SUMMARY = 'weekly_summary'
}

export enum OutboundEmailStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    SENT = 'sent',
    FAILED = 'failed',
    CANCELLED = 'cancelled'
}

export enum InboundEmailStatus {
    PENDING = 'pending',
    PROCESSED = 'processed',
    FAILED = 'failed',
    IGNORED = 'ignored'
}

export enum DigestFrequency {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    NEVER = 'never'
}

export enum AiSuggestionEntityType {
    ORDER = 'order',
    RFQ_SUPPLIER = 'rfq_supplier',
    BATCH = 'batch',
    RFQ_REQUEST = 'rfq_request',
    FOLLOW_UP_CAMPAIGN = 'follow_up_campaign',
    TASK = 'task'
}

export enum AiSuggestionActionType {
    UPDATE_TIMELINE_HEALTH = 'update_timeline_health',
    CHANGE_STATUS = 'change_status',
    CREATE_FOLLOW_UP = 'create_follow_up',
    DRAFT_FOLLOW_UP_EMAIL = 'draft_follow_up_email',
    SEND_REMINDER = 'send_reminder',
    UPDATE_PRIORITY = 'update_priority',
    CREATE_TASK = 'create_task'
}

export enum AiSuggestionStatus {
    PENDING = 'pending',
    REJECTED = 'rejected',
    APPLIED = 'applied',
    REVERTED = 'reverted',
    EXPIRED = 'expired'
}

export enum AiSuggestionPriority {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
    URGENT = 'urgent'
}

export enum EmailDraftType {
    AI_GENERATED = 'ai_generated',
    USER_CREATED = 'user_created',
    TEMPLATE = 'template'
}

export enum EmailDraftPurpose {
    FOLLOW_UP = 'follow_up',
    REMINDER = 'reminder',
    STATUS_REQUEST = 'status_request',
    DOCUMENT_REQUEST = 'document_request',
    QUOTE_REQUEST = 'quote_request',
    GENERAL_INQUIRY = 'general_inquiry'
}

export enum EmailDraftStatus {
    DRAFT = 'draft',
    APPROVED = 'approved',
    SENT = 'sent',
    DISCARDED = 'discarded'
}

export enum EntityEmailStatus {
    NOT_FOUND = 'not_found',
    DRAFT = 'draft',
    QUEUED = 'queued',
    SENT = 'sent',
    FAILED = 'failed'
}

// =====================================================
// TABLE TYPES
// =====================================================

// Companies and Users
export type Company = Tables<'companies'>
export type CompanyInsert = TablesInsert<'companies'>
export type CompanyUpdate = TablesUpdate<'companies'>

export type SupabaseUser = Tables<'users'>
export type SupabaseUserInsert = TablesInsert<'users'>
export type SupabaseUserUpdate = TablesUpdate<'users'>

export type CompanyUser = Tables<'company_users'>
export type CompanyUserInsert = TablesInsert<'company_users'>
export type CompanyUserUpdate = TablesUpdate<'company_users'>

// Customers and Suppliers
export type Customer = Tables<'customers'>
export type CustomerInsert = TablesInsert<'customers'>
export type CustomerUpdate = TablesUpdate<'customers'>

export type Supplier = Tables<'suppliers'>
export type SupplierInsert = TablesInsert<'suppliers'>
export type SupplierUpdate = TablesUpdate<'suppliers'>

export type SupplierAddress = Tables<'supplier_addresses'>
export type SupplierAddressInsert = TablesInsert<'supplier_addresses'>
export type SupplierAddressUpdate = TablesUpdate<'supplier_addresses'>

export type SupplierContact = Tables<'supplier_contacts'>
export type SupplierContactInsert = TablesInsert<'supplier_contacts'>
export type SupplierContactUpdate = TablesUpdate<'supplier_contacts'>

// Projects and Orders
export type Project = Tables<'projects'>
export type ProjectInsert = TablesInsert<'projects'>
export type ProjectUpdate = TablesUpdate<'projects'>

export type Order = Tables<'orders'>
export type OrderInsert = TablesInsert<'orders'>
export type OrderUpdate = TablesUpdate<'orders'>

export type OrderLineItem = Tables<'order_line_items'>
export type OrderLineItemInsert = TablesInsert<'order_line_items'>
export type OrderLineItemUpdate = TablesUpdate<'order_line_items'>

// order views
export type OrderWithRelations = Tables<'orders_with_relations'>
export type OrderLineItemWithPart = Tables<'order_line_items_with_parts'>

export type CompanyAddress = Tables<'company_addresses'>
export type CompanyAddressInsert = TablesInsert<'company_addresses'>
export type CompanyAddressUpdate = TablesUpdate<'company_addresses'>

export type Batch = Tables<'batches'>
export type BatchInsert = TablesInsert<'batches'>
export type BatchUpdate = TablesUpdate<'batches'>

// Batch Production Stage Plans
export type BatchProductionStagePlan = Tables<'batch_production_stage_plans'>
export type BatchProductionStagePlanInsert = TablesInsert<'batch_production_stage_plans'>
export type BatchProductionStagePlanUpdate = TablesUpdate<'batch_production_stage_plans'>

// Batch Current Status View
export type BatchCurrentStatus = Tables<'batch_current_status'>

// Production Stages
export type ProductionStage = Tables<'production_stages'>
export type ProductionStageInsert = TablesInsert<'production_stages'>
export type ProductionStageUpdate = TablesUpdate<'production_stages'>

export type ProjectDocument = Tables<'project_documents'>
export type ProjectDocumentInsert = TablesInsert<'project_documents'>
export type ProjectDocumentUpdate = TablesUpdate<'project_documents'>

export type ProductionStageDocument = Tables<'production_stage_documents'>
export type ProductionStageDocumentInsert = TablesInsert<'production_stage_documents'>
export type ProductionStageDocumentUpdate = TablesUpdate<'production_stage_documents'>

// artificial type for productionStages api
export type ProductionStageAllowedUser = Tables<'production_stage_allowed_users'> & {
    user?: {
        id: string;
        email: string;
        display_name: string | null;
    };
}
export type ProductionStageAllowedUserInsert = TablesInsert<'production_stage_allowed_users'>
export type ProductionStageAllowedUserUpdate = TablesUpdate<'production_stage_allowed_users'>

// Quality Checks
export type QualityChecklistQuestion = Tables<'quality_checklist_questions'>
export type QualityChecklistQuestionInsert = TablesInsert<'quality_checklist_questions'>
export type QualityChecklistQuestionUpdate = TablesUpdate<'quality_checklist_questions'>

export type QualityChecklistPdfReference = Tables<'quality_checklist_pdf_references'>
export type QualityChecklistPdfReferenceInsert = TablesInsert<'quality_checklist_pdf_references'>
export type QualityChecklistPdfReferenceUpdate = TablesUpdate<'quality_checklist_pdf_references'>

export type QualityCheck = Tables<'quality_checks'> & {
    batch_name?: string | null
    order_name?: string | null
    production_stage_name?: string | null
    can_be_thumbnail_shown?: boolean | null
}
export type QualityCheckInsert = TablesInsert<'quality_checks'>
export type QualityCheckUpdate = TablesUpdate<'quality_checks'>

export type Answer = Tables<'answers'>
export type AnswerInsert = TablesInsert<'answers'>
export type AnswerUpdate = TablesUpdate<'answers'>

// Serial Numbers
export type PublicSerialNumber = Tables<'public_serial_numbers'>
export type PublicSerialNumberInsert = TablesInsert<'public_serial_numbers'>
export type PublicSerialNumberUpdate = TablesUpdate<'public_serial_numbers'>

export type PublicSerialNumberQualityCheck = Tables<'public_serial_number_quality_checks'>
export type PublicSerialNumberQualityCheckInsert = TablesInsert<'public_serial_number_quality_checks'>
export type PublicSerialNumberQualityCheckUpdate = TablesUpdate<'public_serial_number_quality_checks'>

export type UsedSerialNumber = Tables<'used_serial_numbers'>
export type UsedSerialNumberInsert = TablesInsert<'used_serial_numbers'>
export type UsedSerialNumberUpdate = TablesUpdate<'used_serial_numbers'>

export type ReservedSerialNumberRange = Tables<'reserved_serial_number_ranges'>
export type ReservedSerialNumberRangeInsert = TablesInsert<'reserved_serial_number_ranges'>
export type ReservedSerialNumberRangeUpdate = TablesUpdate<'reserved_serial_number_ranges'>

// Tasks
export type Task = Tables<'tasks'>
export type TaskInsert = TablesInsert<'tasks'>
export type TaskUpdate = TablesUpdate<'tasks'>

export type TaskAttachment = Tables<'task_attachments'>
export type TaskAttachmentInsert = TablesInsert<'task_attachments'>
export type TaskAttachmentUpdate = TablesUpdate<'task_attachments'>

export type TaskMention = Tables<'task_mentions'>
export type TaskMentionInsert = TablesInsert<'task_mentions'>
export type TaskMentionUpdate = TablesUpdate<'task_mentions'>

export type TaskChecklistItem = Tables<'task_checklist_items'>
export type TaskChecklistItemInsert = TablesInsert<'task_checklist_items'>
export type TaskChecklistItemUpdate = TablesUpdate<'task_checklist_items'>

export type TaskComment = Tables<'task_comments'>
export type TaskCommentInsert = TablesInsert<'task_comments'>
export type TaskCommentUpdate = TablesUpdate<'task_comments'>

// Bill of Materials
export type BillOfMaterials = Tables<'bill_of_materials'>
export type BillOfMaterialsInsert = TablesInsert<'bill_of_materials'>
export type BillOfMaterialsUpdate = TablesUpdate<'bill_of_materials'>

// Bill of Materials views
export type BillOfMaterialsWithParts = Tables<'bill_of_materials_with_parts'>

// Parts Management
export type Part = Tables<'parts'>
export type PartInsert = TablesInsert<'parts'>
export type PartUpdate = TablesUpdate<'parts'>

export type PartAssembly = Tables<'part_assemblies'>
export type PartAssemblyInsert = TablesInsert<'part_assemblies'>
export type PartAssemblyUpdate = TablesUpdate<'part_assemblies'>

export type PartSupplier = Tables<'parts_suppliers'>
export type PartSupplierInsert = TablesInsert<'parts_suppliers'>
export type PartSupplierUpdate = TablesUpdate<'parts_suppliers'>

export type PartsCompatibility = Tables<'parts_compatibility'>
export type PartsCompatibilityInsert = TablesInsert<'parts_compatibility'>
export type PartsCompatibilityUpdate = TablesUpdate<'parts_compatibility'>

export type PartsDocument = Tables<'parts_documents'>
export type PartsDocumentInsert = TablesInsert<'parts_documents'>
export type PartsDocumentUpdate = TablesUpdate<'parts_documents'>

export type PartsPriceHistory = Tables<'parts_price_history'>
export type PartsPriceHistoryInsert = TablesInsert<'parts_price_history'>
export type PartsPriceHistoryUpdate = TablesUpdate<'parts_price_history'>

// part views
export type PartAssemblyWithDetails = Tables<'part_assemblies_with_details'>
export type PartCompatibilityWithDetails = Tables<'parts_compatibility_with_details'>
export type PartSupplierWithDetails = Tables<'parts_suppliers_with_details'>
export type ApprovedPartSupplier = Tables<'approved_parts_suppliers'>
export type LatestPart = Tables<'latest_parts'>
export type PartsDocumentsWithDetails = Tables<'parts_documents_with_details'>

// Other
export type NewUserRequest = Tables<'new_user_requests'>
export type NewUserRequestInsert = TablesInsert<'new_user_requests'>
export type NewUserRequestUpdate = TablesUpdate<'new_user_requests'>

export type ProjectThumbnail = Tables<'project_thumbnails'>
export type ProjectThumbnailInsert = TablesInsert<'project_thumbnails'>
export type ProjectThumbnailUpdate = TablesUpdate<'project_thumbnails'>

export type PaperQualityCheck = Tables<'paper_quality_checks'>
export type PaperQualityCheckInsert = TablesInsert<'paper_quality_checks'>
export type PaperQualityCheckUpdate = TablesUpdate<'paper_quality_checks'>

export type AuditLog = Tables<'audit_logs'>
export type AuditLogInsert = TablesInsert<'audit_logs'>
export type AuditLogUpdate = TablesUpdate<'audit_logs'>

// Signed URL Cache
export type SignedUrlCache = Tables<'signed_url_cache'>
export type SignedUrlCacheInsert = TablesInsert<'signed_url_cache'>
export type SignedUrlCacheUpdate = TablesUpdate<'signed_url_cache'>

export type SignedUrlType = 'document' | 'image' | 'attachment' | 'thumbnail'

// AI
export type AiFeedback = Tables<'ai_feedback'>
export type AiFeedbackInsert = TablesInsert<'ai_feedback'>
export type AiFeedbackUpdate = TablesUpdate<'ai_feedback'>

// RFQ
export type RfqRequest = Tables<'rfq_requests'>
export type RfqRequestInsert = TablesInsert<'rfq_requests'>
export type RfqRequestUpdate = TablesUpdate<'rfq_requests'>

export type RfqLineItem = Tables<'rfq_line_items'>
export type RfqLineItemInsert = TablesInsert<'rfq_line_items'>
export type RfqLineItemUpdate = TablesUpdate<'rfq_line_items'>

export type RfqSupplier = Tables<'rfq_suppliers'>
export type RfqSupplierInsert = TablesInsert<'rfq_suppliers'>
export type RfqSupplierUpdate = TablesUpdate<'rfq_suppliers'>

export type RfqQuote = Tables<'rfq_quotes'>
export type RfqQuoteInsert = TablesInsert<'rfq_quotes'>
export type RfqQuoteUpdate = TablesUpdate<'rfq_quotes'>

export type RfqQuoteLineItem = Tables<'rfq_quote_line_items'>
export type RfqQuoteLineItemInsert = TablesInsert<'rfq_quote_line_items'>
export type RfqQuoteLineItemUpdate = TablesUpdate<'rfq_quote_line_items'>

export type RfqDocument = Tables<'rfq_documents'>
export type RfqDocumentInsert = TablesInsert<'rfq_documents'>
export type RfqDocumentUpdate = TablesUpdate<'rfq_documents'>

// rfq views
export type RfqSupplierWithDetails = Tables<'rfq_suppliers_with_details'>
export type RfqLineItemWithDetails = Tables<'rfq_line_items_with_details'>
export type RfqSupplierCapabilities = Tables<'rfq_supplier_capabilities'>
export type RfqQuoteLineItemWithDetails = Tables<'rfq_quote_line_items_with_details'>
export type RfqQuoteWithDetails = Tables<'rfq_quotes_with_details'>
export type RfqSupplierEmailStatus = Tables<'rfq_supplier_email_status'>


// follow-ups
export type FollowUpCommunication = Tables<'follow_up_communications'>
export type FollowUpCommunicationInsert = TablesInsert<'follow_up_communications'>
export type FollowUpCommunicationUpdate = TablesUpdate<'follow_up_communications'>

export type FollowUpCampaign = Tables<'follow_up_campaigns'>
export type FollowUpCampaignInsert = TablesInsert<'follow_up_campaigns'>
export type FollowUpCampaignUpdate = TablesUpdate<'follow_up_campaigns'>

// email
export type InboundEmail = Tables<'inbound_emails'>
export type InboundEmailInsert = TablesInsert<'inbound_emails'>
export type InboundEmailUpdate = TablesUpdate<'inbound_emails'>

export type EmailQueue = Tables<'email_queue'>
export type EmailQueueInsert = TablesInsert<'email_queue'>
export type EmailQueueUpdate = TablesUpdate<'email_queue'>

export type EmailAttachment = Tables<'email_attachments'>
export type EmailAttachmentInsert = TablesInsert<'email_attachments'>
export type EmailAttachmentUpdate = TablesUpdate<'email_attachments'>

export type CompanyEmailSettings = Tables<'company_email_settings'>
export type CompanyEmailSettingsInsert = TablesInsert<'company_email_settings'>
export type CompanyEmailSettingsUpdate = TablesUpdate<'company_email_settings'>

export type UserEmailPreferences = Tables<'user_email_preferences'>
export type UserEmailPreferencesInsert = TablesInsert<'user_email_preferences'>
export type UserEmailPreferencesUpdate = TablesUpdate<'user_email_preferences'>

export type SentEmail = Tables<'sent_emails'>
export type SentEmailInsert = TablesInsert<'sent_emails'>
export type SentEmailUpdate = TablesUpdate<'sent_emails'>

export type FailedEmail = Tables<'failed_emails'>
export type FailedEmailInsert = TablesInsert<'failed_emails'>
export type FailedEmailUpdate = TablesUpdate<'failed_emails'>

export type EmailDraft = Tables<'email_drafts'>
export type EmailDraftInsert = TablesInsert<'email_drafts'>
export type EmailDraftUpdate = TablesUpdate<'email_drafts'>

export type AiSuggestion = Tables<'ai_suggestions'>
export type AiSuggestionInsert = TablesInsert<'ai_suggestions'>
export type AiSuggestionUpdate = TablesUpdate<'ai_suggestions'>

// Shared interface for entity selection (RFQ, Order, Batch)
export interface EntityShortFormat {
    id: string
    name: string
    description?: string
    status?: string
    meta?: string
    date: string
    entityType: FollowUpEntityType
}


// Re-export the main Database type for direct usage
export type { Database } from './database.types'